import type { FunctionComponent } from 'react';

import { createStyleHelper } from '../../utils/class-names';
import { FormattedMessage } from '../formatted-message/formatted-message';
import { Border, Pill } from '../pill/pill';

import styles from './pill-switcher.module.scss';

const style = createStyleHelper(styles, 'pill-switcher');

export interface IPillSwitcherProps {
    items: Array<{
        id: string;
        name: string;
        href: string;
    }>;
    activeId?: string;
}

function getBorderType(index: number, count: number) {
    if (count === 1) {
        return Border.BOTH;
    }

    if (index === 0) {
        return Border.LEFT;
    }

    if (index === count - 1) {
        return Border.RIGHT;
    }

    return Border.NONE;
}

export const PillSwitcher: FunctionComponent<IPillSwitcherProps> = ({ items, activeId }) => {
    return (
        <nav className={style()}>
            {items.map(({ id, name, href }, i) => {
                return (
                    <Pill
                        key={id}
                        className={style('pill')}
                        border={getBorderType(i, items.length)}
                        href={href}
                        isActive={id === activeId}
                    >
                        <FormattedMessage id={name} defaultMessage={id} />
                    </Pill>
                );
            })}
        </nav>
    );
};
